<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单状态：">
              <el-select size="small" v-model="listParams.orderStatus" style="width: 100%" clearable>
                <el-option value="" label="全部"></el-option>
                <el-option value="01" label="可使用"></el-option>
                <el-option value="02" label="已过期"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="下单日期：">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="预留手机号：">
              <el-input size="small" placeholder="请输入手机号" v-model="listParams.mobile"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-col :span="8">
              <el-form-item>
                <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="exportExcel"> 全部导出 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="orderStatus" align="center" label="订单状态">
          <template slot-scope="scope">
            <span v-show="scope.row.orderStatus === 1" style="color: #008080">可使用</span>
            <span v-show="scope.row.orderStatus === 2" style="color: grey">已过期</span>
          </template>
        </el-table-column>

        <el-table-column prop="orderDate" align="center" label="下单日期">
          <template slot-scope="scope">
            <span>{{ scope.row.orderDate | formatDate }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="ticketsType" align="center" label="票券类型"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="预留手机号"> </el-table-column>

        <el-table-column prop="orderNum" align="center" label="购买数量"> </el-table-column>

        <el-table-column prop="consumeNum" align="center" label="已用数量"> </el-table-column>

        <el-table-column prop="validNum" align="center" label="可用数量"> </el-table-column>

        <el-table-column prop="returnNum" align="center" label="已退数量"> </el-table-column>

        <el-table-column prop="orderSum" align="center" label="订单金额">
          <template slot-scope="scope">
            <span>￥ {{ scope.row.orderSum }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="payment" align="center" label="支付方式"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import { download } from "../../../../utils/javascript/download";

export default {
  data() {
    return {
      carWashId: "",
      listParams: {
        orderStatus: "",
        timeInterval: ["", ""],
        mobile: "",
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
        carWashId: this.carWashId,
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/carwash/order/list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 导出EXCEL
     */
    exportExcel() {
      const exportParams = Object.assign({}, this.listParams, {
        carWashId: this.carWashId,
      });
      exportParams.startDate = exportParams.timeInterval[0];
      exportParams.endDate = exportParams.timeInterval[1];
      delete exportParams.timeInterval;
      // this.$router.open({
      //   path: "/api/web/carwash/order/export",
      //   query: exportParams,
      //   type: "excel"
      // });

      download("/carwash/order/export", exportParams, "订单管理");
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
